module.exports = __webpack_public_path__ + "static/media/HTML5-icon.f8b361ae.png";